import { z } from "zod";

import { packagingComponentBaseSchema } from "./packaging-component-base";

export const packagingComponentPrintSchema = packagingComponentBaseSchema.extend({
	value: z.string().nullish(),
});

export type PackagingComponentPrint = z.infer<typeof packagingComponentPrintSchema>;
